import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { InfoAlert, Text } from 'DVWebNodeUI'
import { StringId } from '../localizer/stringId'
import { IGetString } from '../../utils/stringUtils'
import * as st from './refund.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { withLocalization, LocalizerProps } from '../localizer/localizer'

const refundMultipleNoJSLink = '/digital-orders/ref=atv_dp_core_cancel'
const refundModalPath =
  '/gp/video/widgets/self-service-order-cancel-box/ajax' +
  '/multiple-orders.html/ref=atv_dp_can_ord_modal'

const refundModalLink = (asins: string[]) =>
  `${refundModalPath}?ie=UTF8&asins=${(asins.length && asins.join(',')) ||
    asins}`

const refundModalId = (refundIds: string[] = []) =>
  ['dv_self_cancel', ...refundIds].join('_')

export interface IRefundProps {
  refundableOrders?: WpsRuntime.atv.wps.RefundableOrderProps[]
  refundIds: string[]
}

const refundModalAttrs = (refundIds: string[], getString: IGetString) => ({
  width: 540,
  name: 'refund-order',
  hideHeader: 0,
  showCloseButton: 1,
  buttons: [
    {
      customEvent: 'cancel-order:dv-self-cancel-modal:submit',
      text: getString(StringId.DV_RBB_CANCEL_PURCH_MODAL_SUBMIT),
      id: refundModalId(refundIds),
      type: 'submit'
    }
  ],
  url: refundModalLink(refundIds),
  header: {
    text: getString(StringId.DV_RBB_CANCEL_PURCH_MODAL_HEADER)
  }
})

const createCancelLinkText = (
  href: string,
  getString: IGetString,
  additionalAttr?: { [index: string]: string }
) => ({
  string: getString(StringId.DV_AB_CANCEL_ACCIDENTAL_PURCHASE),
  attrs: { cancelLink: { href, ...additionalAttr } }
})

type CancelLink = IRefundProps & LocalizerProps
const CancelLink = withLocalization(({ refundableOrders, refundIds, getString }: CancelLink) => {
  const multiRefundAttrs = {
    class: 'a-declarative',
    'data-action': 'aiv-modal',
    'data-aiv-modal': JSON.stringify(
      refundModalAttrs(refundIds, getString)
    ),
    name: 'refund-order'
  }
  const cancelLinkText = refundableOrders!.length === 1
    ? createCancelLinkText(refundableOrders![0].singleRefundLink, getString)
    : createCancelLinkText(refundMultipleNoJSLink, getString, multiRefundAttrs)

  return <Text string={cancelLinkText} />
})

export const Refund = (props: IRefundProps) => {
  if (!props.refundableOrders || !props.refundableOrders.length) {
    return null
  }

  return (
    <div className={[st.refundLink, stUtility.fullWidth, 'refund-alert'].join(' ')}>
      <InfoAlert>
        <CancelLink {...props} />
      </InfoAlert>
    </div>
  )
}
